import { Button } from "@cmp-src/primitives/button";
import { MapPinIcon } from "lucide-react";
import type React from "react";
import { useIsMapPinRequestEnabled } from "@/features/map/hooks/useIsMapPinRequestEnabled";
import { useMap } from "@/features/map/MapProvider";

/**
 * Toggle that arms pin-request mode: while on, clicking an empty point on the map
 * drops a pin to file a workplace request (handled by MapPinRequestLayer).
 */
export const MapPinRequestToggle: React.FC = () => {
  const {
    isEmbedded,
    selectionMode,
    isReservationMode,
    isPinRequestMode,
    setIsPinRequestMode
  } = useMap();
  const isMapPinRequestEnabled = useIsMapPinRequestEnabled();

  if (
    !isMapPinRequestEnabled ||
    selectionMode ||
    isReservationMode ||
    isEmbedded
  ) {
    return null;
  }

  // While armed, swap the button for an instructional banner with a cancel action.
  if (isPinRequestMode) {
    return (
      <div className="flex max-w-sm items-center gap-3 rounded-xl border border-neutral-200 bg-white p-3 shadow-lg">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-purple-50 text-purple-600">
          <MapPinIcon className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-medium text-neutral-900 text-sm">
            Pick a location
          </div>
          <div className="text-neutral-500 text-xs">
            Click anywhere on the map to drop a pin for your new request.
          </div>
        </div>
        <Button
          size={"sm"}
          variant={"outlineSecondary"}
          onClick={() => setIsPinRequestMode(false)}
          type="button"
          className={"shrink-0 items-center"}
        >
          Cancel
        </Button>
      </div>
    );
  }

  return (
    <Button
      size={"sm"}
      variant={"outlineSecondary"}
      onClick={() => setIsPinRequestMode(true)}
      type="button"
      iconLeft={<MapPinIcon className="h-4 w-4" />}
      className={"items-center bg-white shadow-md"}
    >
      Report an issue
    </Button>
  );
};
